//////////////////////////////
// デバイス判定
var getDevice = (function(){
	var ua = navigator.userAgent;
	if(ua.indexOf('iPhone') > -1 || ua.indexOf('iPod') > -1 || ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1){
		return 'sp';
	}else if(ua.indexOf('iPad') > -1 || (ua.indexOf('Macintosh') > -1 && 'ontouchend' in document) || ua.indexOf('Android') > -1){
		return 'tab';
	}else{
		return 'pc';
	}
})();

//////////////////////////////
// ブラウザ判定
var getBrowser = (function(){

	var result = 'unknown';
	var agent = navigator.userAgent.toLowerCase();

	if(agent.indexOf('msie') > -1 || agent.indexOf('trident/') > -1){
		result = 'ie';
	}else if(agent.indexOf('edge') > -1){
		result = 'edge';
	}else if (agent.indexOf('chrome') > -1){
		result = 'chrome';
	}else if (agent.indexOf('safari') > -1){
		result = 'safari';
	}else if (agent.indexOf('opera') > -1){
		result = 'opera';
	}else if (agent.indexOf('firefox') > -1){
		result = 'firefox';
	}

	return result;
})();


// クリックイベント設定
var isTouchDevice = (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
var _click = (isTouchDevice) ? 'touchend' : 'click';


(function(){

	var flg_total_init = 0;

	// DOMロード完了
	$(function(){
		flg_total_init++;
		totalInitialize();

		initialize();
		$(window).on('scroll touchmove', onScroll);
		$(window).on('resize', onResize);
	});

	$(window).on('load', onLoad);

	// 全ロード完了
	function onLoad(){
		flg_total_init++;
		totalInitialize();
	}

	function onScroll(){
		scrollSwitch();
		setFloatingbtn();
	}

	function onResize(){
		scrollSwitch();
		setFloatingbtn();
	}


	//////////////////////////////////////
	// 初期処理（DOM load完了）
	function initialize(){
		window.scrollTo(0,0);	// 初期スクロール

		delClass4NoPc();
		afterImages();

		setSmoothScroll();
		setOpenSnsWindow();
		//setLineShareUrl();
		setDisplayZone01();
		scrollSwitchInit();

	}


	//////////////////////////////////////
	// 最終初期処理（全load完了）
	function totalInitialize(){
		if(flg_total_init < 2) return;

		$('html, body').animate({scrollTop:0}, '1');	// 初期スクロール

		setAnimation3D();
		setFloatingbtn();

		setTimeout(function(){
			$('body').addClass('scroll-ok');
			scrollSwitch();
			//ScrollTrigger.refresh();
		}, 500);

	}


	//////////////////////////////////////
	// 3Dアニメ処理
	function setAnimation3D(){

		const width = window.innerWidth;
		const height = window.innerHeight;

		const renderer = new THREE.WebGLRenderer({
			//canvas: document.querySelector('.canvas01')
			canvas: $('.canvas01')[0],
			alpha: true,
		});

		renderer.setSize(width, height);
		renderer.setPixelRatio(window.devicePixelRatio);

		const scene = new THREE.Scene();
		const fov    = 60;
		const fovRad = (fov / 2) * (Math.PI / 180); // 視野角をラジアンに変換
		let dist   = (height / 2) / Math.tan(fovRad); // ウィンドウぴったりのカメラ距離

		// new THREE.PerspectiveCamera(画角, アスペクト比, 描画開始距離, 描画終了距離)
		const camera = new THREE.PerspectiveCamera(45, width / height, 1, dist * 100);
		camera.position.set(0, 0, 0);
		camera.position.z = dist + getDistance();

		const light = new THREE.DirectionalLight(0xffffff);
		light.intensity = 2; // 光の強さを倍に
		light.position.set(1, 1, 1); // ライトの方向
		scene.add(light);

		let geometry = [];
		let texture = [];
		let material = [];
    let gazo = [];

		const textureLoader = new THREE.TextureLoader();
		textureLoader.crossOrigin = true;
		//textureLoader.crossOrigin = 'anonymous';

		for(let i = 0; i < 5; i++){
			geometry[i] = new THREE.PlaneGeometry(1980, 1758);
			//texture[i] = textureLoader.load('/assets/img/map01_0'+i+'.png'); 
			texture[i] = textureLoader.load('https://s.yimg.jp/images/news-cms/feature/visualize/2023/child-grooming/img/map01_0'+i+'.png'); 
			
			material[i] = new THREE.MeshBasicMaterial({map: texture[i], transparent: true});
			gazo[i] = new THREE.Mesh(geometry[i], material[i]);
			gazo[i].position.z = 0
			scene.add(gazo[i]);
		}

		render();
		onScroll3D();

		function render() {
			requestAnimationFrame(render);
			renderer.render(scene, camera);
		}

		window.addEventListener('resize', onResize3D);

		function onResize3D(){
      const width = window.innerWidth;
			const height = window.innerHeight;

			// レンダラーのサイズを調整する
			renderer.setPixelRatio(window.devicePixelRatio);
			renderer.setSize(width, height);

			// カメラのアスペクト比を正す
			camera.aspect = width / height;

			onScroll3D();

			camera.updateProjectionMatrix();			
		}

		window.addEventListener('scroll', onScroll3D);

		function onScroll3D(){
			var st = $(window).scrollTop();
			var wh = window.innerHeight;

			var tg_t00 = $('.js-3d-target').offset().top;
			var tg_t01 = $('.js-3d-target .js-3d-target-area01').offset().top;
			var tg_t02 = $('.js-3d-target .js-3d-target-area02').offset().top;
			var tg_t03 = $('.js-3d-target .js-3d-target-area03').offset().top;
			var tg_t04 = $('.js-3d-target .js-3d-target-area04').offset().top;

			var sp_t01 = $('.js-3d-target .cp-space01').offset().top;
			var sp_t02 = $('.js-3d-target .cp-space02').offset().top;
			var sp_t03 = $('.js-3d-target .cp-space03').offset().top;

			var tg_h00 = $('.js-3d-target').outerHeight();

			var sp_h00 = $('.js-3d-target .cp-space00').outerHeight();
			var sp_h01 = $('.js-3d-target .cp-space01').outerHeight();
			var sp_h02 = $('.js-3d-target .cp-space02').outerHeight();
			var sp_h03 = $('.js-3d-target .cp-space03').outerHeight();

			// 地図領域追従変更
			var tg_bk = $('.areaBack01');
			var tg_bk_li = tg_t00 + tg_h00 - tg_bk.outerHeight();

			if(st < tg_t00){
				tg_bk.css({position:'absolute', top:tg_t00+'px'});
			}
			else if(tg_t00 <= st && st < tg_bk_li){
				tg_bk.css({position:'fixed', top:0});
			}
			else if(tg_bk_li <= st){
				tg_bk.css({position:'absolute', top:tg_bk_li+'px'});
			}

			// 地図3D動作
			var pg = 0;
			var pr = 0.45;

			const DATA_ARR_ALL = [
				// SP
				[
					{x: -125, y:  740, z: 2400},
					{x:  320, y:  260, z: 2400},
					{x: -310, y: -130, z: 2400},
					{x:  225, y: -550, z: 2400},
				],
				// PC
				[
					{x:  200, y:  720, z: 2400 * pr},
					{x:  660, y:  260, z: 2400 * pr},
					{x:   30, y: -130, z: 2400 * pr},
					//{x:  580, y: -550, z: 2400 * pr},
					{x:  460, y: -550, z: 2400 * pr},
				],
			];

			var data_arr;

			if(window.innerWidth < 600){
				// SP
				data_arr = DATA_ARR_ALL[0];
			}else{
				// PC
				data_arr = DATA_ARR_ALL[1];
			}

			dist = (window.innerHeight / 2) / Math.tan(fovRad);

			if(st < tg_t00){
				camera.position.z = dist + getDistance();
			}
			else if((tg_t00 <= st) && (st < tg_t01)){ // スペース
				pg = (st - tg_t00) / (sp_h00 / 2);
				if(pg > 1) pg = 1;
				camera.position.z = dist + getDistance() - (data_arr[0].z * pg);
				camera.position.x = (data_arr[0].x * pg);
				camera.position.y = (data_arr[0].y * pg);
			}
			 if((tg_t01 <= st) && (st < sp_t01)){ // 表示中１
				camera.position.z = dist + getDistance() - (data_arr[0].z);
				camera.position.x = data_arr[0].x;
				camera.position.y = data_arr[0].y;
			}
			else if((sp_t01 <= st) && (st < tg_t02)){ // スペース
				pg = (st - sp_t01) / (sp_h01 / 2);
				pg = (pg > 1) ? 1 : ((pg < 0) ? 0 : pg);
				//camera.position.z = dist + getDistance() - (data_arr[1].z);
				camera.position.z = dist + getDistance() - (data_arr[1].z * getDistancePercent(pg));
				camera.position.x = (data_arr[1].x * pg) + (data_arr[0].x * (1 - pg));
				camera.position.y = (data_arr[1].y * pg) + (data_arr[0].y * (1 - pg));
			}
			else if((tg_t02 <= st) && (st < sp_t02)){ // 表示中２
				camera.position.z = dist + getDistance() - (data_arr[1].z);
				camera.position.x = data_arr[1].x;
				camera.position.y = data_arr[1].y;
			}
			 if((sp_t02 <= st) && (st < tg_t03)){ // スペース
				pg = (st - sp_t02) / (sp_h02 / 2);
				if(pg > 1) pg = 1;
				//camera.position.z = dist + getDistance() - (data_arr[2].z);
				camera.position.z = dist + getDistance() - (data_arr[1].z * getDistancePercent(pg));
				camera.position.x = (data_arr[2].x * pg) + (data_arr[1].x * (1 - pg));
				camera.position.y = (data_arr[2].y * pg) + (data_arr[1].y * (1 - pg));
			}
			else if((tg_t03 <= st) && (st < sp_t03)){ // 表示中３
				camera.position.z = dist + getDistance() - (data_arr[2].z);
				camera.position.x = data_arr[2].x;
				camera.position.y = data_arr[2].y;
			}
			 if((sp_t03 <= st) && (st < tg_t04)){ // スペース
				pg = (st - sp_t03) / (sp_h03 / 2);
				if(pg > 1) pg = 1;
				//camera.position.z = dist + getDistance() - (data_arr[3].z);
				camera.position.z = dist + getDistance() - (data_arr[1].z * getDistancePercent(pg));
				camera.position.x = (data_arr[3].x * pg) + (data_arr[2].x * (1 - pg));
				camera.position.y = (data_arr[3].y * pg) + (data_arr[2].y * (1 - pg));
				actionMapModal02();
			}
			else if(tg_t04 <= st){ // 表示中４
				camera.position.z = dist + getDistance() - (data_arr[3].z);
				camera.position.x = data_arr[3].x;
				camera.position.y = data_arr[3].y;
				actionMapModal02();
			}


			if(st < tg_t00){
				actionMapModal01(-1, 0);
			}
			else if((tg_t00 <= st) && (st < (tg_t01 - wh))){ // スペース
				pg = (st - tg_t00) / (sp_h00 / 2);
				if(pg > 1) pg = 1;
				actionMapModal01(pg, 1);
			}
			else if(((tg_t01 - wh) <= st) && (st < sp_t01)){ // 表示中１
				actionMapModal01(-1, 1);
			}
			else if((sp_t01 <= st) && (st < (tg_t02 - wh))){ // スペース
				pg = (st - sp_t01) / (sp_h01 / 2);
				pg = (pg > 1) ? 1 : ((pg < 0) ? 0 : pg);
				actionMapModal01(pg, 2);
			}
			else if(((tg_t02 - wh) <= st) && (st < sp_t02)){ // 表示中２
				actionMapModal01(-1, 2);
			}
		 	if((sp_t02 <= st) && (st < (tg_t03 - wh))){ // スペース
				pg = (st - sp_t02) / (sp_h02 / 2);
				if(pg > 1) pg = 1;
				actionMapModal01(pg, 3);
			}
			else if(((tg_t03 - wh) <= st) && (st < sp_t03)){ // 表示中３
				actionMapModal01(-1, 3);
			}
			if((sp_t03 <= st) && (st < (tg_t04 - wh))){ // スペース
				pg = (st - sp_t03) / (sp_h03 / 2);
				if(pg > 1) pg = 1;
				actionMapModal01(pg, 4);
			}
			else if((tg_t04 - wh) <= st){ // 表示中４
				actionMapModal01(-1, 4);
			}

		}

		// 地図モーダル動作処理１
		function actionMapModal01(pg = -1, id2 = 0){
			const OP_ST = 0.1; // 透過率
			let id1 = id2 - 1;
			let op = 0;

			if(id2 < 1){
				material[0].opacity = 1;
				material[1].opacity = 1;
				material[2].opacity = 1;
				material[3].opacity = 1;
				material[4].opacity = 1;
				return;
			}

			if(pg == -1){
				material[0].opacity = OP_ST;
				material[1].opacity = OP_ST;
				material[2].opacity = OP_ST;
				material[3].opacity = OP_ST;
				material[4].opacity = OP_ST;
				material[id2].opacity = 1;
				return;
			}

			material[0].opacity = 1;
			material[1].opacity = 1;
			material[2].opacity = 1;
			material[3].opacity = 1;
			material[4].opacity = 1;

			if((id1 > 0) && (0 <= pg && pg <= 0.2)){
				op = (pg / 0.2) * (1 - OP_ST) + OP_ST;
				material[0].opacity = op;
				material[1].opacity = op;
				material[2].opacity = op;
				material[3].opacity = op;
				material[4].opacity = op;
				material[id1].opacity = 1;
			}

			if((id2 > 0) && (0.8 <= pg && pg <= 1)){
				op = ((1 - pg) / 0.2) * (1 - OP_ST) + OP_ST;
				material[0].opacity = op;
				material[1].opacity = op;
				material[2].opacity = op;
				material[3].opacity = op;
				material[4].opacity = op;
				material[id2].opacity = 1;
			}

		}


		// 地図モーダル動作処理２
		function actionMapModal02(){
			var st = $(window).scrollTop();
			var wh = window.innerHeight;

			var tg2 = $('.js-3d-target-area04 .js-message-target');
			var max = tg2.length;
			for(var i = 0; i < max; i++){
				var ot = tg2.eq(i).offset().top;

				if(st > (ot - (wh * 0.7))){
					tg2.eq(i).addClass('current');
				}else{
					tg2.eq(i).removeClass('current');
				}
			}
		}


		function getDistance(){
			if(window.innerWidth < 600){
				return 3200;
			}else{
				return 1800;
			}
		}

		function getDistancePercent(pg){
			const set = 0.8
			return ((set * 4 * ((pg - 0.5) ** 2)) + (1 - set));
			// 放物線で
			// y = x^2
			// y = 4(x - 0.5)^2
			// y = 4a(x - 0.5)^2 + (1 - a)
			//   x : 0 ~ 1
			//   y : 1
			//   a : 0 ~ 1 (距離の割合を設定)
		}


	}



	//////////////////////////////////////
	// スマホ・タブレットに不要class削除
	function delClass4NoPc(){
		if(getDevice != 'pc'){
			$('.hover').removeClass('hover');
			$('.hover01').removeClass('hover01');
			$('.hover02').removeClass('hover02');
			$('.open-window-sns').removeClass('open-window-sns');
		}
	}


	//////////////////////////////////////
	// 非同期画像読み込み
	function afterImages(){
		setTimeout(function(){
			$('img[data-src]').each(function(){
				$(this).attr('src', $(this).attr('data-src'));
			});
		}, 1);
	}


	//////////////////////////////////////
	// スムーズスクロール
	function setSmoothScroll(){
		var speed = 500;

		$('body').on(_click, 'a[href^="#"]', function(){
			var href= $(this).attr('href');
			var target = $(href == '#' || href == '' ? 'html' : href);
			var pos = target.offset().top;
			$('html, body').animate({scrollTop:pos}, speed, 'swing');
			return false;
		});

	}


	//////////////////////////////////////
	// SNSウィンドオープン
	function setOpenSnsWindow(){
		$('body').on(_click, '.open-window-sns', function(){
			var h = 450;
			var w = 600;
			var t = window.screenTop + (window.innerHeight / 2) - (h / 2);
			var l = window.screenLeft + (window.innerWidth / 2) - (w / 2);

			var href = $(this).attr('href');
			window.open(href, 'post-sns', 'width='+w+',height='+h+',top='+t+',left='+l+',menubar=no,toolbar=no,scrollbars=yes');
			return false;
		});
	}


	//////////////////////////////////////
	// LINEシェアURL変更処理
	/*function setLineShareUrl(){
		if(getDevice != 'sp'){
			$('.js-line-url01').each(function(){
				var url = $(this).attr('href');
				url = url.replace('https://line.me/R/msg/text/?', 'https://social-plugins.line.me/lineit/share?text=');
				$(this).attr('href', url);
			});
		}
	}*/


	//////////////////////////////////////
	// ゾーン表示処理
	function setDisplayZone01(){
		$('.js-display-zone01').on(_click, function(){
			$('.js-display-zone01-target').fadeIn();
			$(this).hide();
			$(this).next().show();
			return false;
		});
	}


	//////////////////////////////////////
	// 追従ボタン制御
	function setFloatingbtn(){
		var st = $(window).scrollTop();
		var wh = window.innerHeight;
		var lm1 = $('.area01').offset().top;
		var lm2 = $('.footer01').offset().top;

		var th = $('.floating-btn01').outerHeight();
		var fh = $('.footer01').outerHeight();

		if((lm1 - wh) < st){
			$('.floating-btn01').fadeIn(500);
		}else{
			$('.floating-btn01').fadeOut(500);
		}

		if(st > (lm2 - wh + th)){
			$('.floating-btn01').css({
				position: 'absolute',
				bottom: fh,
			});
		}else{
			$('.floating-btn01').css({
				position: 'fixed',
				bottom: '6%',
			});
		}

	}


	//////////////////////////////////////
	// スクロールスイッチ
	function scrollSwitchInit(){
		$('.js-effect').each(function(){
			var tg = $(this);

			if(tg.hasClass('e00')){
				gsap.set(tg, {opacity:0});
			}
			if(tg.hasClass('e01')){
				gsap.set(tg, {opacity:0});
			}
			if(tg.hasClass('e02')){
				gsap.set(tg, {opacity:1, scaleX:0, scaleY:1, transformOrigin:'left top'});
			}

		});
	}

	function scrollSwitch(){
		if(!$('body').hasClass('scroll-ok')) return;

		var st = $(window).scrollTop();
		var wh = $(window).height();
		var oy = st + (wh * 0.7);

		$('.js-effect').each(function(){
			var tg = $(this);
			var tt = tg.offset().top;

			if(tg.hasClass('ex01')){
				if(tt < oy){
					tg.addClass('current');
				}else{
					tg.removeClass('current');
				}
			}

			if(!tg.hasClass('e-end')){
				if((oy - wh) < tt && tt < oy){

					// フェードイン1
					if(tg.hasClass('e00')){
						tg.addClass('e-end');
						gsap.to(tg, {duration: 0.8, opacity:1, ease:Power1.easeIn});
					}

					// フェードイン2
					if(tg.hasClass('e01')){
						tg.addClass('e-end');
						gsap.to(tg, {duration: 0.5, opacity:1, ease:Power1.easeIn});
					}

					// ライン引き1
					if(tg.hasClass('e02')){
						tg.addClass('e-end');
						gsap.to(tg, {duration: 0.8, scaleX:1, scaleY:1, ease:Power0.easeNone});
					}

					// ライン引き（デバイスフォント）
					if(tg.hasClass('e03')){
						tg.addClass('e-end');
						var pcnt = 0.002
						var dr = tg.width() * pcnt;
						gsap.to(tg, {duration: dr, backgroundSize: '100% 4px', ease:Power0.easeNone});
					}

					// e-area01
					if(tg.hasClass('e-area00')){
						tg.addClass('e-end');
						setAnimeArea00();
					}

					// e-area01
					if(tg.hasClass('e-area01')){
						tg.addClass('e-end');
						setAnimeArea01();
					}

					// e-area02
					if(tg.hasClass('e-area02')){
						tg.addClass('e-end');
						setAnimeArea02();
					}

					// e-area03
					if(tg.hasClass('e-area03')){
						tg.addClass('e-end');
						setAnimeArea03();
					}

					// e-area04
					if(tg.hasClass('e-area04')){
						tg.addClass('e-end');
						setAnimeArea04();
					}

					// e-area05
					if(tg.hasClass('e-area05')){
						tg.addClass('e-end');
						setAnimeArea05();
					}

					// e-area06
					if(tg.hasClass('e-area06')){
						tg.addClass('e-end');
						setAnimeArea06();
					}

					// e-area07
					if(tg.hasClass('e-area07')){
						tg.addClass('e-end');
						setAnimeArea07();
					}

					// e-area08
					if(tg.hasClass('e-area08')){
						tg.addClass('e-end');
						setAnimeArea08();
					}

					// e-area09
					if(tg.hasClass('e-area09')){
						tg.addClass('e-end');
						setAnimeArea09();
					}

				}
			}
		});

	}


	//////////////////////////////////////
	// e-area01アニメ
	function setAnimeArea00(){
		var tg = '.e-area00';
		var tm = 0.5;

		gsap.set(tg+'__parts01', {opacity:0, x:'35%', y:'-4%'});
		gsap.set(tg+'__parts02', {opacity:0, x:'-30%', y:'30%'});

		gsap.to(tg+'__parts01', {x:0, y:0, ease: Power1.easeIn, duration: 0.8, delay: tm+0});
		gsap.to(tg+'__parts01', {opacity:1, ease: Power1.easeIn, duration: 1.4, delay: tm+0});

		gsap.to(tg+'__parts02', {opacity:1, x:0, y:0, ease: Power1.easeIn, duration: 0.8, delay: tm+0});

	}


	//////////////////////////////////////
	// e-area01アニメ
	function setAnimeArea01(){
		var tg = '.e-area01';
		var tm = 0;

		gsap.to(tg, {opacity:1, ease:Power1.easeIn, duration: 0.8, delay: tm+0});

		gsap.set(tg+'__parts01', {opacity:1, scaleX:0, scaleY:1, transformOrigin:'left top'});
		gsap.to(tg+'__parts01', {scaleX:1, scaleY:1, ease:Power2.easeOut, duration: 0.8, delay: tm+1});

		gsap.to(tg+'__parts02_01', {opacity:1, ease:Power1.easeIn, duration: 0.2, delay: tm+1.8});
		gsap.to(tg+'__parts02_02', {opacity:1, ease:Power1.easeIn, duration: 0.2, delay: tm+2.2});
		gsap.to(tg+'__parts02_03', {opacity:1, ease:Power1.easeIn, duration: 0.2, delay: tm+2.6});

	}


	//////////////////////////////////////
	// e-area01アニメ
	function setAnimeArea02(){
		var tg = '.e-area02';
		var tm = 0;

		gsap.to(tg+'__parts01', {opacity:1, ease:Power1.easeIn, duration: 0.8, delay: tm+0});

		gsap.set(tg+'__parts02_01', {opacity:1, scaleX:0, scaleY:1, transformOrigin:'left top'});
		gsap.to(tg+'__parts02_01', {scaleX:1, scaleY:1, ease:Power2.easeOut, duration: 0.6, delay: tm+1});

		gsap.set(tg+'__parts02_02', {opacity:1, scaleX:0, scaleY:1, transformOrigin:'left top'});
		gsap.to(tg+'__parts02_02', {scaleX:1, scaleY:1, ease:Power2.easeOut, duration: 0.6, delay: tm+1.8});

		gsap.set(tg+'__parts02_03', {opacity:1, scaleX:0, scaleY:1, transformOrigin:'left top'});
		gsap.to(tg+'__parts02_03', {scaleX:1, scaleY:1, ease:Power2.easeOut, duration: 1.0, delay: tm+1});

		gsap.to(tg+'__parts03_01', {opacity:1, ease:Power1.easeIn, duration: 0.2, delay: tm+2.2});
		gsap.to(tg+'__parts04_01', {backgroundSize:'100% 4px', ease:Power0.easeNone, duration:0.6, delay:tm+2.4});

		gsap.to(tg+'__parts03_02', {opacity:1, ease:Power1.easeIn, duration: 0.2, delay: tm+3.0});
		gsap.to(tg+'__parts04_02', {backgroundSize:'100% 4px', ease:Power0.easeNone, duration:0.6, delay:tm+3.2});

		gsap.to(tg+'__parts03_03', {opacity:1, ease:Power1.easeIn, duration: 0.2, delay: tm+3.8});
		gsap.to(tg+'__parts04_03', {backgroundSize:'100% 4px', ease:Power0.easeNone, duration:0.8, delay:tm+4.0});

	}


	//////////////////////////////////////
	// e-area03アニメ
	function setAnimeArea03(){
		var tg = '.e-area03';
		var tm = 0;

		// グラフ動作
		var graph_data = [130, 163, 223, 244, 265, 264, 335, 266, 264, 243];

		var cal_speed = function(num){
			return num / 335 * 0.6;
		};

		gsap.set(tg+'__parts01', {transformOrigin: 'bottom left'});

		for(var cnt = 0; cnt < graph_data.length; cnt++){
			var s = cal_speed(graph_data[cnt]);
			gsap.fromTo($(tg+'__parts01').eq(cnt), {opacity:0}, {duration: 0.2, opacity:1, delay: tm+0});
			gsap.fromTo($(tg+'__parts01').eq(cnt), {scaleY: '0%'}, {duration: s, scaleY: '100%', ease: Linear.easeNone, delay: tm+0});
			gsap.fromTo($(tg+'__parts02').eq(cnt), {opacity:0}, {opacity:1, delay: tm+0.2+s});
		}

	}


	//////////////////////////////////////
	// e-area04アニメ
	function setAnimeArea04(){
		var tg = '.e-area04';
		var tm = 0;

		gsap.to(tg, {opacity:1, ease:Power1.easeIn, duration: 0.8, delay: tm+0});
		gsap.to(tg+'__parts01', {backgroundSize:'100% 4px', ease:Power0.easeNone, duration:0.6, delay:tm+0.8});
		gsap.to(tg+'__parts02', {opacity:1, ease:Power1.easeIn, duration: 0.8, delay: tm+1.4});

	}


	//////////////////////////////////////
	// e-area05アニメ
	function setAnimeArea05(){
		var tg = '.e-area05';
		var tm = 0;

		gsap.to(tg, {opacity:1, ease:Power1.easeIn, duration: 0.8, delay: tm+0});
		gsap.to(tg+'__parts01', {backgroundSize:'100% 4px', ease:Power0.easeNone, duration:0.6, delay:tm+0.8});

	}


	//////////////////////////////////////
	// e-area06アニメ
	function setAnimeArea06(){
		var tg = '.e-area06';
		var tm = 0;

		gsap.to(tg, {opacity:1, ease:Power1.easeIn, duration: 0.8, delay: tm+0});
		gsap.to(tg+'__parts01', {backgroundSize:'100% 4px', ease:Power0.easeNone, duration:0.6, delay:tm+0.8});

	}


	//////////////////////////////////////
	// e-area07アニメ
	function setAnimeArea07(){
		var tg = '.e-area07';
		var tm = 0;

		gsap.to(tg, {opacity:1, ease:Power1.easeIn, duration: 0.8, delay: tm+0});

	}


	//////////////////////////////////////
	// e-area08アニメ
	function setAnimeArea08(){
		var tg = '.e-area08';
		var tm = 0;

		gsap.to(tg, {opacity:1, ease:Power1.easeIn, duration: 0.8, delay: tm+0});
		gsap.to(tg+'__parts01', {backgroundSize:'100% 4px', ease:Power0.easeNone, duration:0.6, delay:tm+0.8});
		gsap.to(tg+'__parts02', {backgroundSize:'100% 4px', ease:Power0.easeNone, duration:0.6, delay:tm+1.4});

	}


	//////////////////////////////////////
	// e-area09アニメ
	function setAnimeArea09(){
		var tg = '.e-area09';
		var tm = 0;

		gsap.to(tg+'__parts01', {backgroundSize:'100% 4px', ease:Power0.easeNone, duration:1.0, delay:tm+0.0});
		gsap.to(tg+'__parts02', {backgroundSize:'100% 4px', ease:Power0.easeNone, duration:1.0, delay:tm+1.0});

	}


})();